export default function getFromQuery(location) {
  return `from=${encodeURIComponent(location.pathname + location.search)}`;
}
